/* eslint no-underscore-dangle: ["error", { "allow": ["_id"]}] */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import TimeLinePagenation from './TimeLinePagenation';
import DeviceList from './DeviceList';
import * as types from '../../lib/constants';

import unknownImage from '../../images/media/noimage.jpg';
import thumbnailGroup1 from '../../images/media/img_group_01.svg';
import thumbnailGroup3 from '../../images/media/img_group_02.svg';

const mediaThumnails = [
  unknownImage,
  thumbnailGroup1,
  thumbnailGroup3,
  thumbnailGroup1,
];

// タイムラインエリアで調整する高さ
const adjustmentHeight = 0;
const titleHeight = 40;
const timelineTitleMargin = 15;
// タイムラインのtableで調整する高さ
const pagenationHeight = 40;

const style = {
  main: {
    height: '100%',
    flex: '1 1 0%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  table: {
    width: '100%',
    height: `calc(100% - ${pagenationHeight}px)`,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#1E1F2C',
  },
  thead: {
    flex: '0 0 auto',
    backgroundColor: '#202232',
  },
  tbody: {
    overflowY: 'scroll',
    backgroundColor: '#1E1F2C',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    border: '2px solid #202232',
    color: '#fff',
    textDecoration: 'none',
    margin: 4,
    backgroundColor: '#2f3243',
    height: 54,
  },
  listhead: {
    display: 'flex',
    alignItems: 'flex-end',
    borderTop: '2px solid #202232',
    color: '#fff',
    height: 27,
    fontSize: 12,
  },
  operator: {
    display: 'flex',
    flexDirection: 'row',
  },
  mediaIconP: {
    height: 40,
    cursor: 'pointer',
  },
  mediaIconL: {
    width: 50,
    cursor: 'pointer',
  },
  thumbnail: {
    width: 58,
    height: 54,
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '#2f3243', // 画像の背景
  },
  imageWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  nodata: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 'bold',
  },
};

const OperatorInfo = styled.div`
  width: 100%;
  background-color: #3a3e52;
`;
const TitleBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #43528a;
  color: #fff;
  width: atuo;
  margin-top: ${props => props.margin};
  padding: 15px;
  height: ${props => props.height};
`;
const TitleBarText = styled.div``;
const TimeLineContents = styled.div`
  display: ${props => (props.displayTimeLineList ? 'flex' : 'none')};
  flex-direction: column;
  height: ${props => `calc(100% - ${props.subtract}px)`};
`;
const NoDeviceMessage = styled.div`
  height: ${props => props.height};
  display: flex;
  justify-contents: flex-start;
  align-items: center;
  padding-left: 15px;
`;

const createList = (idx, list) => {
  const mediaType = list.mediaType || 0;
  const thumbnailUrl = list.thumbnailUrl || null;
  const mediaIconStyle =
    list.orientation === 'P' ? style.mediaIconP : style.mediaIconL;
  return (
    <div style={style.list} key={idx}>
      <div style={{ ...style.operator, ...style.thumbnail }}>
        <div style={style.imageWrapper}>
          <img
            src={
              mediaType !== types.IMAGE
                ? mediaThumnails[mediaType]
                : thumbnailUrl
            }
            alt="IMG"
            style={mediaIconStyle}
          />
        </div>
      </div>
    </div>
  );
};

const MobileTimeLineLists = ({
  timelines,
  pagenation,
  searchOptions,
  displayDeviceList,
  displayTimelineList,
  toggleDeviceList,
  toggleTimeLineList,
  onSelect,
  userDevices,
  onSendLocation,
  onDeleteDevice,
}) => {
  const isDeviceExist = userDevices.length > 0;
  const timelineTitleHeight = titleHeight + timelineTitleMargin;
  const timelineSubtract = titleHeight + timelineTitleHeight + adjustmentHeight;
  return (
    <div style={style.main} className="mobileMain">
      <OperatorInfo>
        {(isDeviceExist && (
          <DeviceList
            userDevices={userDevices}
            displayDeviceList={displayDeviceList}
            toggleDeviceList={() => toggleDeviceList()}
            onDelete={id => onDeleteDevice(id)}
            onSendLocation={id => onSendLocation(id)}
          />
        )) || (
          <NoDeviceMessage height={`${titleHeight}px`}>
            <FormattedMessage id="timeLine.deviceList.sp.noDevice" />
          </NoDeviceMessage>
        )}
      </OperatorInfo>
      <TitleBar
        id="toggleTimeLineList"
        onClick={() => toggleTimeLineList()}
        height={`${titleHeight}px`}
        margin={`${timelineTitleMargin}px`}
      >
        <TitleBarText>
          <FormattedMessage id="timeLine.title" />
        </TitleBarText>
      </TitleBar>
      <TimeLineContents
        displayTimeLineList={displayTimelineList}
        subtract={timelineSubtract}
      >
        <div style={style.table}>
          <div style={style.tbody} id="canScrollTable">
            {(timelines &&
              timelines.length > 0 &&
              timelines.map((list, idx) => createList(idx, list))) || (
              <div style={style.nodata}>
                <div>
                  <FormattedMessage id="timeLine.nodata" />
                </div>
              </div>
            )}
          </div>
        </div>
        <TimeLinePagenation
          pagenation={pagenation}
          searchOptions={searchOptions}
          onSelect={page => onSelect(page)}
        />
      </TimeLineContents>
    </div>
  );
};

MobileTimeLineLists.propTypes = {
  userDevices: PropTypes.array.isRequired,
  timelines: PropTypes.array.isRequired,
  pagenation: PropTypes.object.isRequired,
  searchOptions: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired,
  toggleDeviceList: PropTypes.func.isRequired,
  toggleTimeLineList: PropTypes.func.isRequired,
  displayDeviceList: PropTypes.bool.isRequired,
  displayTimelineList: PropTypes.bool.isRequired,
  onSendLocation: PropTypes.func.isRequired,
  onDeleteDevice: PropTypes.func.isRequired,
};

export default MobileTimeLineLists;
